import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Button } from './Button';
export function StickyCTA() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      // Show after scrolling past hero (~600px)
      if (window.scrollY > 600) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <AnimatePresence data-id="element-281">
      {isVisible && <motion.div initial={{
      y: 100
    }} animate={{
      y: 0
    }} exit={{
      y: 100
    }} className="fixed bottom-0 left-0 w-full bg-ivory border-t border-stone-200 p-4 shadow-[0_-10px_20px_rgba(0,0,0,0.05)] z-40 md:hidden" data-id="element-282">
          <div className="flex items-center justify-between gap-4 max-w-md mx-auto" data-id="element-283">
            <div className="flex flex-col" data-id="element-284">
              <span className="text-xs text-slate-500 font-medium" data-id="element-285">Desde</span>
              <span className="text-lg font-bold text-blue-900" data-id="element-286">
                $19.990 ARS
              </span>
            </div>
            <Button href="#planes" className="py-3 px-6 text-sm flex-grow" data-id="element-287">
              🧠 Quiero mi Megapack
            </Button>
          </div>
        </motion.div>}
    </AnimatePresence>;
}